<template>
  <section class="terms">
    <div class="terms__wrapper grid grid-xs-center">
      <nav>
        <ul class="terms__links">
          <li>
            <a
              href="https://tunirexun.com/site/privacy-policy"
              target="_blank"
              rel="noopener"
              class="terms__link"
            >
              <AppTag type="regular">Privacy policy </AppTag>
            </a>
          </li>
          <li>
            <a
              href="https://tunirexun.com/site/terms-conditions"
              target="_blank"
              rel="noopener"
              class="terms__link"
            >
              <AppTag type="regular">Terms and conditions </AppTag>
            </a>
          </li>
          <li>
            <a
              :href="FAQ_URL"
              target="_blank"
              rel="noopener"
              data-qa="login-faq-link"
              class="terms__link"
            >
              <AppTag type="regular">Help/FAQs</AppTag>
            </a>
          </li>
        </ul>
      </nav>
      <div class="terms__logos">
        <div class="terms__text-wrapper">
          <AppTag type="regular">A TOOL FROM</AppTag>
          <span class="terms__logo brand-font_700">MoneySavingExpert</span>
        </div>
        <div class="terms__text-wrapper terms__text-wrapper_tu">
          <AppTag type="regular">POWERED BY <span class="u-a11y">TransUnion</span></AppTag>
          <span class="terms__logo terms__logo_icon"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import AppTag from '@/components/topography/AppTag.vue';
  import { FAQ_URL } from '@/constants/urls';
</script>

<style scoped lang="scss">
  .terms {
    display: flex;
    justify-content: center;
    background: $expanded-extra-grey-5;

    &__wrapper {
      width: 100%;
      max-width: $max-static-content-width;
    }

    &__links {
      display: flex;
      flex-wrap: wrap;
      grid-gap: 24px;
      margin-bottom: 0;
      flex-direction: column;
      text-align: center;
      margin-bottom: 2rem;

      @include new-ms {
        flex-direction: row;
        justify-content: center;
        margin-bottom: 0;
      }
    }

    &__link {
      color: $brand-primary-100-navy;
    }

    &__logos {
      display: flex;
      flex-direction: column;
      gap: 24px;

      @include new-ms {
        flex-direction: row;
      }
    }

    &__text-wrapper {
      display: flex;
      flex-direction: column;
      gap: 24px;
      align-items: center;
      color: $brand-primary-100-navy;

      @include new-ms {
        flex-direction: row;
        align-items: flex-end;
      }

      &_tu {
        flex-direction: row;
        align-items: end;

        @include new-ms {
          align-items: flex-end;
        }
      }
    }

    &__logo {
      display: inline-block;
      font-size: remc(20px);
      line-height: remc(20px);
      color: $brand-secondary-100-red;

      &_icon {
        width: 100px;
        height: 29px;
        background-image: url('@/assets/icons/trans-union-logo.svg');
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
</style>
